exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media (min-width:200px){cookies-consent .infoCookies{top:inherit;bottom:0;z-index:100}cookies-consent .infoCookies a{float:right;margin-top:-5px;margin-right:-5px}cookies-consent button{padding:.75em 1em .7em!important}cookies-consent button:after{content:none!important}cookies-consent .dark{background-color:#262625!important;color:#fff!important}cookies-consent .dark:hover{background-color:#666!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./src/app/common/cookies-consent/cookies-consent.styl
// module id = 603
// module chunks = 0